import { ISegment, ISegmentIndexParams, ISegmentIndexResponse } from "models/Segmet";
import fetcher, { STATUS_OK } from "../../libs/fetcher";

export const indexSegments = async ({ project_id }: ISegmentIndexParams): Promise<ISegmentIndexResponse> => {
    const url = `/projects/${project_id}/segments`;
    let response: ISegmentIndexResponse = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET'
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;
        
        // console.log("🚀 ~ indexSegments ~ fetch:", fetch)
        
        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData: ISegment[] = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData)) {
                    response.data = responseData;
                    response.error = false;
                    response.totalItems = responseData.length;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}